import { useMemo } from 'react';
import styled from 'styled-components';
import { Delete16 } from 'ui/icons/aurora/16px/Delete16';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { spacing } from 'ui/theme';
import { useDeleteImageOverlayContext } from 'modules/creativeLibrary/contexts/DeleteImageOverlayContext';
import { useTranslations } from 'modules/creativeLibrary/hooks/useTranslations';
import { useUploadAssetsContext } from 'modules/creativeLibrary/contexts/UploadAssetsContext';
import { UploadAssetList } from '../components/UploadAssetList';

const ButtonBar = styled.div`
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  padding: ${spacing.base};
  section {
    column-gap: ${spacing.base};
    display: flex;
  }
`;

const ScrollableContainer = styled.div`
  flex: 1 1 auto;
  overflow: auto;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
`;

export const testIds = {
  buttonDelete: 'cl-index-takeover-list-button-delete',
  buttonDeselectAll: 'cl-index-takeover-list-button-deselect',
  buttonSelectAll: 'cl-index-takeover-list-button-select-all',
  buttonMoveToFolder: 'cl-index-takeover-list-button-move-to-folder',
};

export const UploadList = () => {
  const { t } = useTranslations();

  const { pendingImages, setSelectedAssets } = useUploadAssetsContext();
  const { setImgsIdsToDelete } = useDeleteImageOverlayContext();

  const idsSelected = useMemo(
    () => pendingImages.filter((pi) => pi.isSelected).map((pi) => pi.id),
    [pendingImages],
  );
  const isAllSelected = useMemo(() => pendingImages.every((pi) => pi.isSelected), [pendingImages]);

  const handleDelete = () => {
    setImgsIdsToDelete(idsSelected);
  };

  return (
    <>
      <ButtonBar>
        <section>
          {isAllSelected ? (
            <Button
              data-test={testIds.buttonDeselectAll}
              onClick={() => setSelectedAssets([])}
              size={BUTTON_SIZES.SMALL}
              variant={BUTTON_VARIANTS.SECONDARY}
            >
              {t('button.deselectAll')}
            </Button>
          ) : (
            <Button
              data-test={testIds.buttonSelectAll}
              onClick={() => setSelectedAssets(pendingImages.map((pi) => pi.id))}
              size={BUTTON_SIZES.SMALL}
              variant={BUTTON_VARIANTS.SECONDARY}
            >
              {t('button.selectAll')}
            </Button>
          )}
        </section>
        <section>
          <Button
            data-test={testIds.buttonDelete}
            isDisabled={!idsSelected.length}
            onClick={handleDelete}
            size={BUTTON_SIZES.SMALL}
            variant={BUTTON_VARIANTS.SECONDARYDESTRUCTIVE}
          >
            <Delete16 />
            {t('button.delete')}
          </Button>
        </section>
      </ButtonBar>
      <ScrollableContainer>
        <List>
          <UploadAssetList />
        </List>
      </ScrollableContainer>
    </>
  );
};
